import VehicleSimilar from "./views/similar/similar";

const RentalVehicles = {

    init() {
        this.el = $('[module="rental_vehicles"]');

        if (!this.el.length) {
            return;
        }

        this.bind();
    },

    bind() {
    },

    load(url, data) {
        url = url || Rental.currentUrl();
        this.url = url;

        const hash = rentalHash ? `&hash=${rentalHash}` : ''
        const page_id = window.ID_PAGE

        return $.ajax({
            type: 'POST',
            url: `/modules/rental_vehicles/vehicles.async.php?go=${url}${hash}&page_id=${page_id}`,
            data: JSON.stringify(data),
            contentType: 'application/json',
            dataType: 'html',
            success: (response) => {
                this.afterLoad(response);
            },
            error: (xhr, status, error) => {
                console.error('Error:', error);
            }
        })
    },

    afterLoad(response) {
        VehicleSimilar.replaceVehicles(response);
    },
};

export default RentalVehicles;